export const packages = {
  'Available Areas': 'Áreas disponibles',
  'Choose your areas!': '¡Elegí tus áreas!',
  Contract: 'Contrato',
  'Minimum date for scheduling {{date}}':
    'Fecha mínima para la programación: {{date}}',
  Packages: 'Paquetes',
  'Remove all': 'Eliminar todo',
  'Select all': 'Seleccionar todo',
  'Select an area to see the duration':
    'Seleccioná un área para ver la duración',
  'Select below which areas would you like to schedule':
    'Seleccioná abajo qué áreas querés agendar',
  'Select date': 'Seleccioná fecha',
  'Session duration {{duration}} minutes':
    'Duración de la sesión: {{duration}} minutos',
  "You don't have areas to schedule yet": 'Todavía no tenés áreas para agendar',
  'Your sessions of {{items}} can only be scheduled and performed in the unit they were adquired':
    'Tus sesiones de {{items}} solo pueden ser agendadas y realizadas en la unidad donde fueron adquiridas',
};
